import { UiSliderNewNavigation } from '@frontend/znanie-uikit';
import type { UiSliderNewProps } from '@frontend/znanie-uikit';

export const sliderProps: UiSliderNewProps = {
  spaceBetween: 0,
  slidesPerView: 'auto',
  slidesOffsetAfter: 15,
  modules: [UiSliderNewNavigation],
  breakpoints: {
    769: {
      spaceBetween: 15,
      slidesOffsetAfter: 0,
      slidesPerView: 3,
    },
    989: {
      spaceBetween: 15,
      slidesOffsetAfter: 0,
      slidesPerView: 4,
    },
    1200: {
      spaceBetween: 15,
      slidesOffsetAfter: 0,
      slidesPerView: 5,
    },
  },
};
